export const EntityTypeId = Object.freeze({
	Company: 'COMPANY',
	Contact: 'CONTACT',
	Deal: 'DEAL',
	Lead: 'LEAD',
});
